var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 11.6667V4.66675M18.6666 8.16675H25.6666M18.6666 24.5001V23.1001C18.6666 21.1399 18.6666 20.1598 18.2851 19.4111C17.9496 18.7525 17.4141 18.2171 16.7556 17.8816C16.0069 17.5001 15.0268 17.5001 13.0666 17.5001H7.93325C5.97307 17.5001 4.99298 17.5001 4.24429 17.8816C3.58572 18.2171 3.05029 18.7525 2.71473 19.4111C2.33325 20.1598 2.33325 21.1399 2.33325 23.1001V24.5001M14.5833 8.75008C14.5833 11.0052 12.7551 12.8334 10.4999 12.8334C8.24476 12.8334 6.41659 11.0052 6.41659 8.75008C6.41659 6.49492 8.24476 4.66675 10.4999 4.66675C12.7551 4.66675 14.5833 6.49492 14.5833 8.75008Z",
    stroke: "#121215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/Assign.e2fb8925cef03e3525cb0931ab41a13d.svg";
export { ForwardRef as ReactComponent };